<template>
<div>
	<div class="product-name">{{productName}}</div>
	<Steps :current="index" style="margin:0 auto; width:700px;padding-left:116px">
	    <Step title="申请信息"></Step>
	    <Step title="确认信息"></Step>
	    <Step title="支付"></Step>
	</Steps>
</div>
</template>
<script>
export default {
	props:{
		index:Number,
		productName:String
	},
}
</script>
<style scoped>
	.product-name{
		margin-bottom: 20px;
		font-size: 18px;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/Steps.vue